module.exports = __webpack_public_path__ + "img/20200512_163623.499c3263.jpg";